import React from 'react';
import MaskedInput from 'react-text-mask';
import { StyledTextbox } from '@nib-components/textbox';
import BaseFormField from '../base-form-field';
import { AddFunnelPropFromContext } from '../funnel-context';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
import { defaultFieldPropTypes } from '../../types';
const LABELS = {
  ARHI: DEFAULT_LABELS.POST_CODE
};
const mask = [/\d/, /\d/, /\d/, /\d/]; // 4 digits
const AusPostcode = props => {
  const {
    funnel = FUNNELS.ARHI,
    help = '',
    width = 4,
    optional = false
  } = props;
  return React.createElement(BaseFormField, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    width: width,
    help: help,
    optional: optional
  }, React.createElement(MaskedInput, {
    guide: false,
    mask: mask,
    ...props.field,
    render: (ref, props) => React.createElement(StyledTextbox, {
      ref: ref,
      ...props,
      autoComplete: "postal-code",
      inputMode: "numeric",
      pattern: "\\d*"
    })
  }));
};
const AusPostcodeWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(AusPostcode, {
  ...props
}));
AusPostcode.defaultProps = {
  ...defaultFieldPropTypes,
  width: 4
};
export default AusPostcodeWithFunnel;